import React from 'react';
export function OfferSection() {
  return <section id="offer" className="w-full bg-white flex items-center justify-center" style={{
    padding: '32px 0',
    fontFamily: 'Inter, sans-serif'
  }} aria-label="Sonderangebot" data-id="element-188">
      <div className="flex flex-col md:flex-row" style={{
      maxWidth: 1000,
      width: '100%',
      backgroundColor: '#F5F5F5',
      borderRadius: 8,
      overflow: 'hidden'
    }} data-id="element-189">
        {/* Left - Product Image */}
        <div style={{
        padding: 32
      }} data-id="element-190">
          <img src="https://cdn.magicpatterns.com/uploads/mCCGmE2VRx1kRPBa5AV5Vb/30_Rabatt_(6).jpg" alt="MaleUp 3x Anti-Aging Face Cream + GRATIS Augenserum – Du sparst insgesamt 60€" style={{
          maxWidth: 456,
          width: '100%',
          height: 'auto',
          borderRadius: 8
        }} className="object-cover" data-id="element-191" />
        </div>

        {/* Right - Offer Details */}
        <div className="flex flex-col items-center justify-center flex-1" style={{
        padding: '25px 24px'
      }} data-id="element-192">
          {/* Special offer badge */}
          <div className="flex items-center justify-center w-full" style={{
          maxWidth: 456,
          height: 42,
          border: '1px solid #DDDDDD'
        }} data-id="element-193">
            <span className="font-semibold text-center uppercase" style={{
            fontSize: 14,
            lineHeight: '22.4px',
            color: '#1A1A1A'
          }} data-id="element-194">
              🎁 Spezielles Angebot für Leser dieses Artikels
            </span>
          </div>

          {/* Gold headline */}
          <h2 className="font-bold text-center mt-4" style={{
          fontSize: 36,
          lineHeight: '43.2px',
          color: '#D4A24C',
          maxWidth: 434
        }} data-id="element-195">
            BIS ZU 60€ SPAREN NUR FÜR KURZE ZEIT!
          </h2>

          {/* Subtext */}
          <p className="font-light text-center mt-4" style={{
          fontSize: 16,
          lineHeight: '24px',
          color: '#1A1A1A',
          maxWidth: 447
        }} data-id="element-196">
            Dieses limitierte Angebot läuft bei hoher Nachfrage aus und
            <br data-id="element-197" />
            der Vorrat wird schnell knapp.
          </p>

          {/* CTA Button */}
          <a href="https://maleup.de/products/quiz-deal-3x-anti-aging-face-cream?variant=52835646537995" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center mt-5 hover:opacity-90 transition-opacity" style={{
          maxWidth: 456,
          width: '100%',
          height: 90,
          backgroundColor: '#1A1A1A',
          borderRadius: 8
        }} data-id="element-198">
            <span className="font-bold text-center text-white" style={{
            fontSize: 18,
            lineHeight: '28.8px'
          }} data-id="element-199">
              JETZT MALEUP MIT 60€ RABATT SICHERN →
            </span>
          </a>

          {/* Info line */}
          <div className="flex items-center justify-center gap-1 mt-4" style={{
          fontSize: 14,
          lineHeight: '22.4px'
        }} data-id="element-200">
            <span className="font-light" style={{
            color: '#1A1A1A'
          }} data-id="element-201">
              Ausverkaufsrisiko:
            </span>
            <span className="font-bold" style={{
            color: '#E63946'
          }} data-id="element-202">
              Hoch
            </span>
            <span className="font-light" style={{
            color: '#999999'
          }} data-id="element-203">
              |
            </span>
            <span className="font-light" style={{
            color: '#1A1A1A'
          }} data-id="element-204">
              kostenloser Versand
            </span>
          </div>

          {/* Guarantee text */}
          <p className="font-light text-center mt-3" style={{
          fontSize: 13,
          lineHeight: '20.8px',
          color: '#666666'
        }} data-id="element-205">
            Profitiere noch heute von unserer 30-Tage-Geld-zurück-Garantie
          </p>
        </div>
      </div>
    </section>;
}